(function ($) {
  "use strict";
  const SHOW_CLASS = "show";
  const COOKIE_NAME = "ACCEPTANCE_COOKIES";
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 год

  const $popup = $(".js-acceptance-cookies");

  function getCookie(name) {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );

    return matches ? decodeURIComponent(matches[1]) : null;
  }

  function setCookie(name, value, options = null) {
    options = {
      path: "/",
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    if (options.expires && typeof options.expires === "number") {
      var d = new Date();
      d.setTime(d.getTime() + options.expires * 1000);
      options.expires = options.expires = d;
    }

    let updatedCookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];

      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  function setConfirmCookie() {
    setCookie(COOKIE_NAME, "1", { expires: COOKIE_MAX_AGE });
  }

  function initEvents() {
    $popup.on("click", ".js-confirm-popup", function (e) {
      setConfirmCookie()
      $popup.removeClass(SHOW_CLASS);
    });
  }

  $(document).ready(function () {
    if (getCookie(COOKIE_NAME)) {
      return;
    }

    $popup.addClass(SHOW_CLASS);
    initEvents()
  });
})(jQuery);
